import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-product',
  templateUrl: './product.page.html',
  styleUrls: ['./product.page.scss'],
})
export class ProductPage implements OnInit {
  id;
  token = '';
  adds = [];
  product:any = {};
  selected_option = 0;
  amount = 1;


  constructor(public activedRoute:ActivatedRoute, public http:HttpClient, public toastCtrl:ToastController, public alertCtrl:AlertController, public navCtrl:NavController, public modalController:ModalController) {

  }

  back(){
    this.modalController.dismiss({
      'dismissed': true
    });

    //this.navCtrl.back();
  }


  getProduct(){
    this.http.post<any>('https://api.blowjob.cherish.com.ua/api/get_product', {
      id:this.id,
      token: this.token
    }).subscribe(async res => {
      if (res.error_code == 0) {
        this.product = res.data.product;

        if(this.product.option.values.length > 0){
          this.product.price = this.product.option.values[0].price;
        }

      } else {
        await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Возникла ошибка', buttons: ["OK"] }))).present();
      }
    }, async err => {
      await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Проверьте интернет-соединение', buttons: ["OK"] }))).present();
    })
  }

  ngOnInit() {    
    //this.id = this.activedRoute.snapshot.paramMap.get('id');
    this.token = localStorage.getItem('token');
    this.getProduct();
  }

  dec(){if(this.amount > 1) this.amount--;}
  inc(){this.amount++;}

  add(){
    let option_id = 0;
    if(this.product.option.values.length > 0){
      option_id = this.product.option.values[this.selected_option].id;
    }
    this.http.post<any>('https://api.blowjob.cherish.com.ua/api/add_cart', {
      id:this.id,
      token: this.token,
      product_id: this.product.id,
      amount: this.amount,
      adds: this.adds,
      option_id: option_id
    }).subscribe(async res => {
      if (res.error_code == 0) {
        await (await (this.toastCtrl.create({ message: 'Товар добавлен в корзину', duration: 1000 }))).present();
      } else {
        await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Возникла ошибка', buttons: ["OK"] }))).present();
      }
    }, async err => {
      await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Проверьте интернет-соединение', buttons: ["OK"] }))).present();
    })
  }

  async select_add(add){
    let found = false;
    await this.adds.forEach(add_item => {
      if(this.adds.indexOf(add.id) > -1){
        found = true;
      }
    });

    if(found == false){
      this.adds.push(add.id);
      this.product.price = Number(this.product.price) + Number(add.price);
    } else {
      this.product.price = Number(this.product.price) - Number(add.price);
      this.adds.splice(this.adds.indexOf(add.id), 1);
    }
  }

  async select_option(i){
    this.product.price = Number(this.product.price) - Number(this.product.option.values[this.selected_option].price) + Number(this.product.option.values[i].price);
    
    this.selected_option = i;
  }

}
